import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'

export interface CashAuthState {
  authToken?: string
  journeyId: string
  maskedDeliveryTarget?: string
}

export const cashAuthInitialState: CashAuthState = {
  authToken: undefined,
  journeyId: uuidv4(),
  maskedDeliveryTarget: undefined,
}

const cashAuthSlice = createSlice({
  name: 'cashAuth',
  initialState: cashAuthInitialState,
  reducers: {
    setIdentifySuccess(
      state,
      action: PayloadAction<{
        authToken: string
        maskedDeliveryTarget?: string
      }>
    ) {
      state.authToken = action.payload.authToken
      state.maskedDeliveryTarget = action.payload.maskedDeliveryTarget
    },
    setVerifySuccess(state, action: PayloadAction<{ authToken: string }>) {
      state.authToken = action.payload.authToken
    },
    resetCashAuth(state) {
      state.authToken = undefined
      state.maskedDeliveryTarget = undefined
      state.journeyId = uuidv4()
    },
  },
})

export const { setIdentifySuccess, setVerifySuccess, resetCashAuth } = cashAuthSlice.actions

export default cashAuthSlice.reducer
